import { createRouter, createWebHistory } from 'vue-router';
import LoginPage          from '../components/LoginPage.vue';
import LoginAccrFleet     from '../components/LoginAccrFleet.vue';
import MainPage           from '../components/MainPage.vue';
import DashboardMainPage  from '../components/dashboard/DashboardPage.vue';
import DashboardMainPageV2 from '../components/dashboard/DashboardPageV2.vue';
import DashboardHelpPage  from '../components/dashboard/HelpPage.vue';
import PasswordChange     from '../components/PasswordChange.vue';
import MainLogPage        from '../components/logs/MainLogPage.vue';

// lazy-loaded
// const Profile = () => import("./components/Profile.vue")

const routes = [
  { path: '/',
    name: 'loginCompany',
    component: () => import("../components/LoginCompany.vue")
  },
  //{ path: '/chara',  component: () => import("../components/LoginAccr.vue") },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/loginAccrFleet',
    name: 'loginAccrFleet',
    component: LoginAccrFleet
  },
  {
    path: '/changePassword',
    name: 'passwordChange',
    component: PasswordChange
  },
  {
    path: '/main',
    name: 'main',
    component: MainPage
  },
  {
    path: '/logs',
    name: 'appWrkLogs',
    component: MainLogPage
  },
  {
    path: '/dash',
    name: 'dashboardMain',
    component: DashboardMainPage
  },
  {
    path: '/dashV2',
    name: 'dashboardMainV2',
    component: DashboardMainPageV2
  },
  {
    path: '/dashHelp',
    name: 'dashboardHelp',
    component: DashboardHelpPage
  },
  {
    path: '/dashArch',
    name: 'dashboardArchived',
    component: DashboardHelpPage
    //component: DashboardArchivedPage
  },
  {
    path: '/dashArch',
    name: 'dashboardDeleted',
    component: DashboardHelpPage
    //component: DashboardDeletedPage
  }  
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/', '/login', '/loginAccrFleet', '/register', '/home', '/logs'];
  const authRequired = !publicPages.includes(to.path);
  const userAuth = localStorage.getItem('user');
  // trying to access a restricted page + not logged in redirect to login page
  if (authRequired && !userAuth) {
    next('/');
  } else if (authRequired) {
    let token;
    try{
        token = JSON.parse(userAuth);
        if(token.accessToken?.length>=128) {
            next(); // looks like correct token, lets conntinue
        } else {
            next('/'); // too short token, login again
        }
    } catch(err){ next('/'); }

  } else {
    next();
  }
});

export default router;
